import { useQuery } from 'react-apollo';

import { accountProfileById } from '../../../../apps/web-gallery/views/UserPage/graphql';
import { getAccountOrganizationName } from '../../../../util/account';

const useContributorBusinessCard = ({ accountId }) => {
  const { data: { accountProfile } = {}, loading } = useQuery(
    accountProfileById,
    {
      variables: {
        id: accountId,
      },
      skip: !accountId,
      fetchPolicy: 'cache-first',
    },
  );

  return {
    loading,
    name: getAccountOrganizationName(accountProfile, accountProfile?.name),
    logo: accountProfile?.logo_image,
    siteUrl: accountProfile?.site_url,
    photoAttributionPage: accountProfile?.photo_attribution_page,
  };
};

export default useContributorBusinessCard;
